import comp from "./AddRandomQuestions";
export default comp;
